import { Chip as CXChip } from '@sanlamcx/react-ui-next-chip';

type Chip = typeof CXChip;
export const Chip: Chip = CXChip;
